// extracted by mini-css-extract-plugin
export default {"cls1":"mWpK98o6moiqRJWhVM7B","cls2":"OhT7jCIdMtiesWHpf10F mWpK98o6moiqRJWhVM7B"};